function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHand = function SvgHand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "var(--primary-color, #000)",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    },
    d: "m 16,17.5 c 0,-1.6569 -1.343146,-3 -3,-3 -1.656854,0 -3,1.3431 -3,3 L 10,38 c 0,10 6.777192,16.780467 14,17 6.730971,0 10,-3 14,-11 l 6,-16 c 0.806848,-1.4472 0.290884,-3.28695 -1.15625,-4.09375 -1.447134,-0.8068 -3.286902,-0.2597 -4.09375,1.1875 L 34,34 M 28,30 28,7.5 c 0,-1.6569 -1.343146,-3 -3,-3 -1.656854,0 -3,1.3431 -3,3 l 0,21.53125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22,26.6 0,-19.1 c 0,-1.6569 -1.343146,-3 -3,-3 -1.656854,0 -3,1.3431 -3,3 l 0,19.1",
    style: {
      fill: "none",
      stroke: "var(--primary-color, #000)",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34,30.6 0,-22.5 c 0,-1.6569 -1.343146,-3 -3,-3 -1.656854,0 -3,1.3431 -3,3 l 0,19.1",
    style: {
      fill: "none",
      stroke: "var(--primary-color, #000)",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hand.1e0abd81.svg";
export { ForwardRef as ReactComponent };